/* Knopf „Mitteilungen auf diesem Gerät" (Pia, 30.10.2026). Auf dem iPhone geht das nur, wenn das CRM als Home-Bildschirm-App
   installiert ist (iOS 16.4+): dann steht ein Hinweis da. */
import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Bell, BellOff } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { pushAnschalten, pushAusschalten, pushMoeglich, pushStand } from '@/lib/piaPush';

const ios = () => /iPhone|iPad/.test(navigator.userAgent);
const alsApp = () => window.matchMedia?.('(display-mode: standalone)').matches || window.navigator.standalone;

export default function PiaPush() {
  const [stand, setStand] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { pushStand().then(setStand); }, []);
  if (stand === null) return null;

  const umschalten = async () => {
    setBusy(true);
    try {
      if (stand === 'an') { await pushAusschalten(); toast.success('Mitteilungen auf diesem Gerät sind aus.'); }
      else { await pushAnschalten(); toast.success('Mitteilungen sind an.'); }
    } catch (e) { toast.error(e?.response?.data?.detail || e.message || 'Nicht geklappt'); }
    setStand(await pushStand()); setBusy(false);
  };

  if (stand === 'nicht_moeglich') {
    return <p className="text-xs text-muted-foreground" data-testid="pia-push-hinweis">
      {ios() && !alsApp() ? 'iPhone: Teilen › „Zum Home-Bildschirm“, dann das CRM von dort öffnen — erst dann gehen Mitteilungen.' : 'Dieses Gerät kann keine Mitteilungen anzeigen.'}</p>;
  }
  if (stand === 'blockiert') return <p className="text-xs text-muted-foreground">Mitteilungen sind im Browser blockiert. Erlaube sie in den Einstellungen der Seite.</p>;
  return (
    <Button size="sm" variant={stand === 'an' ? 'outline' : 'default'} onClick={umschalten} disabled={busy || !pushMoeglich()} className="gap-1.5" data-testid="pia-push-knopf">
      {stand === 'an' ? <BellOff className="w-4 h-4" /> : <Bell className="w-4 h-4" />}
      {stand === 'an' ? 'Mitteilungen auf diesem Gerät ausschalten' : 'Mitteilungen auf diesem Gerät'}
    </Button>
  );
}
